/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import {Component, Watch} from 'vue-property-decorator'
import Vue from 'vue'
import {namespace} from 'vuex-class'
import {
  EQUIPMENT_CURRENT_SET,
  EQUIPMENT_EDIT,
  EQUIPMENT_GET,
  MAINTENANCE_GET_MAINTENANCES,
  MAINTENANCE_MODULE_NAMESPACE,
  MAINTENANCE_RESET_MAINTENANCES,
  MAINTENANCE_SET_MAINTENANCES,
  VEHICLE_GET
} from '../../../store/maintenance'
import * as moment from 'moment'
import {MaintenanceService} from '../../../services'
import { IMaintenanceSearchParams } from '../../../store/maintenance/maintenance-state.store'
import { eventBus } from '../../../main'
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_SAVE_DOCUMENT, DOCUMENT_SET_DOCUMENT_ACTION, DOCUMENT_UPDATE_DOCUMENT } from '../../../store/document'
import { CrudStatus } from '../../../common/enums'

const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

interface ICost {
  fk_category:number
  fk_subcategory:number
  name:string
  costs:any[]
  total:number
  pagination:{page:number,rowsPerPage:number}
  loading:boolean
}


@Component({
  components: {
    'user-profile-widget': async () => import('@/components/user-profile-widget/UserProfileWidget.vue'),
    'user-profile-enhanced-widget': async () => import('@/components/user-profile-enhanced-widget/UserProfileEnhancedWidget.vue'),
    'block-infos-loader': async () => import('../loaders/block-infos-loader/BlockInfosLoader.vue'),
    'maintenance-item': async () => import('../block-maintenances/maintenance-list-item/MaintenanceListItem.vue'),
    'document-modal-vertical': async () => import('../../documents/components/document-modal-vertical/DocumentModalVertical.vue'),
    'last-documents': async () => import('../components/block-equipment-documents/BlockEquipmentDocuments.vue')
  }
})

class BlockVehicleDetail extends Vue {
  @MaintenanceStore.Getter currentEquipment: any;
  @MaintenanceStore.Action(VEHICLE_GET)
  storeGetVehicle: (id: any) => Promise<any>
  @MaintenanceStore.Mutation(EQUIPMENT_CURRENT_SET)
  storeSetEquipment: (equipment: any) => void
  @MaintenanceStore.Action(EQUIPMENT_EDIT)

  @MaintenanceStore.Getter maintenances: any[]
  @MaintenanceStore.Action(MAINTENANCE_GET_MAINTENANCES)
  storeGetMaintenances: (payload: IMaintenanceSearchParams) => Promise<{data:any[],limit:number, skip: number,total: number}>;
  @MaintenanceStore.Mutation(MAINTENANCE_SET_MAINTENANCES)
  storeSetMaintenances: (data:any[]) => void;

  @MaintenanceStore.Mutation(MAINTENANCE_RESET_MAINTENANCES)
  storeResetMaintenances: (payload:any[]) => void;

  @DocumentStore.Action(DOCUMENT_SAVE_DOCUMENT)
  storeRecordDocument: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_UPDATE_DOCUMENT)
  storeUpdateDocument: () => Promise<any>

  @DocumentStore.Getter documentCrudActionStatus: CrudStatus

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_ACTION)
  storeSetDocumentAction : (action:CrudStatus) => void;

  _cleatTimeout: any;
  dtMessageErrorModel: boolean
  dtError: any
  dtIsLoading: boolean
  dtIsRecording: boolean
  dtModalAttribute: boolean
  dtModalAddDoc:boolean
  dtEquipment:any
  dtCost:ICost[]
  CostTab:string
  Costheaders:any[]
  CostLoaded:boolean
  Costpagination: any
  dtRules: {
    text?: any,
    number?: any,
    bool?: any,
    // date?: any
  }
  maintenanceService: any
  attributeToEdit: any
  currentAttribute: any
  dateMenu: boolean
  hoverImg: boolean
  file: any;
  loadUpdateImage: boolean
  loaderValue: any;
  dtDocumentConfigs: { minimum: number, image: { alpha: number }, video: { alpha: number }, document: { alpha: number } }
  isLoading:boolean
  lastDocsKey:number


  constructor() {
    super()
    this.dtMessageErrorModel = false
    this.dtError = null
    this.dtIsLoading = false
    this.dtIsRecording = false
    this.dtModalAttribute = false
    this.dtModalAddDoc = false
    this.dtEquipment = null
    this.dtCost = []
    this.CostTab = null
    this.Costheaders=[
      { text: 'Date', value: 'billing_date', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Fournisseur', value: 'provider', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Quantité', value: 'quantity', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Montant HT', value: 'amount', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Facture', value: 'invoice_link', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
    ]
    this.CostLoaded = false
    this.Costpagination = {
      page: 1,
      rowsPerPage: 1
    }
    this.attributeToEdit = null
    this.dateMenu = false
    this.maintenanceService = new MaintenanceService()
    this.hoverImg = false
    this.dtDocumentConfigs = null;
    this.loaderValue = { percentage: 0 };
    this.file = null;
    this.loadUpdateImage = false
    this.isLoading = false
    this.lastDocsKey = 1
  }

  get lblSetting () {
    return {
      ...require('@/locales/equipment').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/block').default,
      ...require('@/locales/agency-management').default,
      ...require('@/locales/button').default,
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/document').default
    }
  }



  get coLoader (): boolean {
    return !this.currentEquipment
  }

  get avatarColor (): string {
    if (this.currentEquipment.disable) return 'grey'
    return 'primary'
  }

  get computedDateFormattedMomentjs () {
    return this.attributeToEdit ? moment(this.attributeToEdit).format('DD/MM/YYYY') : ''
  }

  get textConfigs () {
    return require('@/assets/json-resources/text-field-configs.json')
  }
  get equipmentBgContainerStyle () {
    const defaultBg = require.context('../../../assets/background/',false,/\.(png|svg)$/)
    let defaultEquipmentBg = defaultBg('./no-image.png');
    return this.currentEquipment.picture
      ? {'background-image': 'url(' + this.currentEquipment.picture+')'}
      : {'background-image': 'url(' + defaultEquipmentBg +')'};
  }


  getEquipmentName()
  {
    return this.currentEquipment.reference ? `(${this.currentEquipment.reference}) - ${this.currentEquipment.name}` : this.currentEquipment.name
  }

  updateDocById()
  {
    console.log('----------updateDocById-------')
    this.dtEquipment = this.currentEquipment
    this.dtModalAddDoc = true
  }


  mounted () {
    eventBus.$on('ADD_DOCUMENT_TO_EQUIPMENT',data=>{
      this.storeSetDocumentAction(CrudStatus.Create)
      console.log(data.equipment)
      this.dtEquipment = data.equipment
      this.dtModalAddDoc = true
    })

    eventBus.$on('RELOAD_ON_DELETE_LAST_DOC',()=>{
      console.log('EVENT =============== RELOAD_ON_DELETE_LAST_DOC')
      this.loadPage()
    })

    this.loadPage()
    this.$watch('$route.params', ({ id, cid }) => {
      this.loadPage()
    })
    this.dtRules = {
      text: [v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.lblValue)})]
    }
    this.dtDocumentConfigs = require('../../../configs/ticket-document-maxsize.config.json');
  }

  beforeDestroy()
  {
    eventBus.$off('ADD_DOCUMENT_TO_EQUIPMENT')
    eventBus.$off('RELOAD_ON_DELETE_LAST_DOC')
    this.storeResetMaintenances([])
  }

  loadPage () {
    this.isLoading = true
    this.lastDocsKey++
    moment.locale('fr')
    this.storeGetVehicle(this.$route.params.cid).then(()=>{
      //console.log('===============> COST : ',this.currentEquipment.cost)
      // get COSTS
      Promise.all(this.currentEquipment.cost.map(async (el)=>{
        const response = await this.maintenanceService.getVehicleCost({
          equipment:this.$route.params.cid,
          category:el.cat_id,
          subcategory:el.scat_id,
          $limit:10,
          $skip:0
        })
        return {
          fk_category:el.cat_id,
          fk_subcategory:el.scat_id,
          name:el.scat_name,
          costs:response.data,
          total:response.total,
          pagination:{
            page: 1,
            rowsPerPage: 10
          },
          loading:false
        }
      })).then((values)=>{
        this.CostLoaded = true
        console.log('END ==============',values)
        values.forEach((val:ICost)=>{
          this.dtCost.push(val)
        })
      })
    }).then(()=>{
      this.storeGetMaintenances({equipment:parseInt(this.$route.params.cid),$limit:50,$skip:0}).then((response)=>{
        this.storeSetMaintenances(response.data)
      }).finally(()=>{
        console.log(this.dtCost)
      })
    }).finally(()=>{
      this.isLoading = false
    })
  }


  /* @Watch('dtCost',{deep:true})
  dtCostChanged(val)
  {
    console.log(val)
  } */

  updatePagination(pagination,costId,subCostId)
  {
    if(this.CostLoaded)
    {
      console.log(pagination,costId,subCostId)
      this.dtCost.map(async (cost)=>{
        if(cost.fk_category===costId && cost.fk_subcategory===subCostId)
        {
          cost.loading = true
          const limit = pagination.rowsPerPage
          const skip = (pagination.page-1)*pagination.rowsPerPage
          const response = await this.maintenanceService.getVehicleCost({
            equipment:this.$route.params.cid,
            category:costId,
            subcategory:subCostId,
            $limit:limit,
            $skip:skip
          })
          cost.costs = response.data
          cost.loading = false
        }
      })
    }
  }

  goToTab(name)
  {
    console.log(this.$route)
    const el = document.getElementById('cost-details')
    el.scrollIntoView()
    this.CostTab = name
  }


  formatDate (date) {
    return date ? moment(date).fromNow() + ' (' + moment(date).format('DD/MM/YYYY') + ')' : ''
  }

  formatCostDate (date) {
    return date ? moment(date).format('DD/MM/YYYY') : ''
  }

  handleEditAttribute (item) {
    this.currentAttribute = item
    if (item.attribute_value) {
      this.attributeToEdit = item.attribute_value.value
    } else {
      this.attributeToEdit = null
    }
    this.dtModalAttribute = true
  }

  handleSaveAttribute () {
    this.dtIsRecording = true
    this.maintenanceService.patchEquipmentAttribute(this.$route.params.cid, this.currentAttribute.id, {
      value: this.attributeToEdit
    })
      .then(response => {
        this.dtModalAttribute = false
        let currentEqp = Object.assign({}, {...this.currentEquipment})
        let currentAttrIdx = currentEqp.attributes.findIndex(x => x.id === this.currentAttribute.id)
        currentEqp.attributes[currentAttrIdx] = response
        this.storeSetEquipment(currentEqp)
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
      })
  }

  handleSaveDoc()
  {
    if (this.isCreateAction) {
      console.log('handleSaveDoc ...')
      this.dtIsRecording = true
      eventBus.$emit('DOC_SAVE_FILES_ATTRIBUTES')
      this.storeRecordDocument()
      .then(response => {
        console.log('response=', response)
        //this.$router.go(0)
        eventBus.$emit('RELOAD_BLOCK_DASHBORD',this.$route.params.id)
      })
      .catch(err => {
        //this.dtErrorModalVisible = true
        //this.dtError = err
      })
      .finally(() => {
        this.storeResetMaintenances([])
        this.dtCost = []
        this.loadPage()
        this.dtIsRecording = false
        this.dtModalAddDoc = false
      })
    }

    if (this.isUpdateAction) {
      console.log('handleSaveDoc ...')
      this.dtIsRecording = true
      eventBus.$emit('DOC_SAVE_FILES_ATTRIBUTES')
      this.storeUpdateDocument()
      .then(response => {
        console.log('response=', response)
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.storeResetMaintenances([])
        this.dtCost = []
        this.loadPage()
        this.dtIsRecording = false
        this.dtModalAddDoc = false
      })
    }
  }


  get isUpdateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Update
  }

  get modalTitle() {
    return this.isCreateAction ? this.$t(this.lblSetting.documentAdd) : this.$t(this.lblSetting.documentEditOrShare)
  }

  get isCreateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Create
  }

  handleClose () {
  }

  handleBeforeModalClose () {
    this.attributeToEdit = null
  }

  handleError (error) {
    this.dtError = error
    this.dtMessageErrorModel = true
  }

  handleRemoveError () {
    this.dtMessageErrorModel = false
    this.dtError = null
  }

  formatBoolean (val) {
    return val ? this.$t(this.lblSetting.amCalculableTrue) : this.$t(this.lblSetting.amCalculableFalse)
  }

  private calculateMaxSize(type): number {
    return this.dtDocumentConfigs[type].alpha * this.dtDocumentConfigs.minimum
  }

  handleImageMouseOver(){
    this.hoverImg= true
  }

  handleImageMouseLeave(){
    this.hoverImg= false
  }

  handleClickPicture() {
    if(!this.loadUpdateImage && this.$route.meta['manage_equipment']) (this.$refs['file'] as any).click();
  }

  handleZoomPicture() {
   (this.$refs['btn_zoom'] as any).click();
  }

  private async getBase64URL(file): Promise<FileReader> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    return Promise.resolve(fileReader);
  }

  async handleFileUpload({ files }) {
    if (files.length === 0) return;
    this.loadUpdateImage = true
    const maxSize: number = this.calculateMaxSize('image');
    if (maxSize < files[0].size) {
      alert(`File too large. The size can not exceed ${maxSize / 1024 / 1024}`);
      this.loadUpdateImage = false;
      return;
    }
    await this.getBase64URL(files[0])
      .then((fileReader: FileReader) => {
        const file = files[0];
        file.id = `${file.lastModified}`;
        fileReader.onloadend = () => {
          file.url = fileReader.result;
        }
        return Promise.resolve(file)
      })
      .then(file => {
        setTimeout(() => {
          this.loaderValue.percentage= 100
          this.updateEquipmentPicture(file.url)
          this.$emit('updateImage',file.url)

        }, 100);
      })
      .catch(error => console.log(error))
  }

  updateEquipmentPicture (file) {
    this.dtIsRecording = true
    this.maintenanceService.patchEquipment(this.$route.params.cid, {
      picture: file
    })
      .then(response => {
        let currentEqp = Object.assign({}, {...this.currentEquipment})
        currentEqp.picture = response.picture;
        this.storeSetEquipment(currentEqp)
      })
      .catch(this.handleError)
      .finally(() => {
        this.dtIsRecording = false
        this.loadUpdateImage = false

      })
  }

  paramImage(params) {
    params.picture = this.file.url;
    params.percentage = 0;
    this.loaderValue = params;
  }

  updateImage(params) {
    if (this.file !== null) {
      this.paramImage(params)
    }
  }
}

export default BlockVehicleDetail



// WEBPACK FOOTER //
// ./src/containers/block/block-vehicle-detail/index.ts